// src/stone/illustrations/StonjiCreditCardIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiCreditCardIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "M64 64V0H0v64z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M56 44.877V19.091a3.89 3.89 0 0 0-3.89-3.891H12.86a3.89 3.89 0 0 0-3.89 3.89v25.787a3.89 3.89 0 0 0 3.89 3.891h39.248A3.89 3.89 0 0 0 56 44.878"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M49.3 18.55a3.35 3.35 0 1 0 6.7 0 3.35 3.35 0 0 0-6.7 0M49.3 45.418a3.35 3.35 0 1 0 6.7 0 3.35 3.35 0 0 0-6.7 0M8.97 18.55a3.35 3.35 0 1 0 6.7 0 3.35 3.35 0 0 0-6.7 0M8.97 45.418a3.35 3.35 0 1 0 6.7 0 3.35 3.35 0 0 0-6.7 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M15.69 37.862a1.678 1.678 0 1 0 3.357 0 1.678 1.678 0 0 0-3.356 0M32.485 37.862a1.678 1.678 0 1 0 3.357 0 1.678 1.678 0 0 0-3.357 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M17.37 36.187v3.36h16.793v-3.36zM40.884 26.1a1.678 1.678 0 1 0 3.357 0 1.678 1.678 0 0 0-3.357 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M40.884 29.46a1.678 1.678 0 1 0 3.357 0 1.678 1.678 0 0 0-3.357 0M45.923 26.1a1.678 1.678 0 1 0 3.357 0 1.678 1.678 0 0 0-3.357 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M45.923 29.46a1.678 1.678 0 1 0 3.357 0 1.678 1.678 0 0 0-3.357 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M40.884 26.304v2.961c0 1.036.84 1.876 1.876 1.876h4.647c1.036 0 1.876-.84 1.876-1.876v-2.961c0-1.036-.84-1.876-1.876-1.876H42.76c-1.036 0-1.876.84-1.876 1.876"
        }
      )
    ]
  }
);
var StonjiCreditCardIllustration_default = StonjiCreditCardIllustration;

export {
  StonjiCreditCardIllustration_default
};
